// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f6da216a","732":"7d7e54c6","977":"8d5fa6cd"}[chunkId] + ".chunk.js";
};